import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';

import LoadMask from 'components/LoadMask';
import CommunicationMessageDialog from 'scenes/Dialog/components/CommunicationMessageDialog';
import LinkButton from 'components/LinkButton';
import PagePagination from 'components/PagePagination';
import FiltersContentLoader from 'components/FiltersContentLoader';

import { ENDPOINT } from 'constants/endpoints';
import { useGrid } from 'hooks/useGrid';

import './styles.css';

const CommunicationsWidget = forwardRef((props, ref) => {
  const { id } = props;

  const grid = useGrid(
    ENDPOINT.COLLECTION.CANDIDATE_PROFILE_COMMUNICATION,
    null,
    false
  );

  const {
    data: { isFetching },
  } = useGrid(ENDPOINT.COLLECTION.CANDIDATE_PROFILE_COMMUNICATION, null, false);

  useEffect(() => {
    grid.actions.fetch({ candidateId: id });
  }, []);

  useImperativeHandle(ref, () => ({
    reload: () => {
      grid.actions.fetch();
    },
  }));

  const showMessage = id => {
    CommunicationMessageDialog({ id });
  };

  return !isFetching ? (
    Number(grid.data.rowsCount) > 0 ? (
      <div className="communications-widget sidebar__widget">
        {grid.data.isFetching && <LoadMask relative />}
        <div className="sidebar__block">
          <h3 className="sidebar__title" style={{ marginBottom: '5px' }}>
            Communication
          </h3>
          <p className="sidebar__subtitle">Team Member Messages</p>
        </div>

        <div className="sidebar__block">
          <div className="communications-widget__items">
            {grid.data.rows.map(record => (
              <div
                className="communications-widget__item"
                key={record.MessageID}
              >
                <div className="communications-widget__item-name">
                  <span className="communications-widget__accent">
                    {record.FullName}
                  </span>
                </div>
                <div className="communications-widget__data">
                  <div className="sidebar__text">
                    Type:{' '}
                    <LinkButton
                      text={record.Type}
                      controlFunc={() => showMessage(record.MessageID)}
                      btnFontWeight="600"
                      btnFontSize="0.8571rem"
                      underline={false}
                      btnFontFamily="Noto Sans"
                      btnStyles={{
                        textAlign: 'left',
                      }}
                    />
                  </div>
                </div>
                <div className="communications-widget__data">
                  <div className="sidebar__text">Date: {record.Date}</div>
                </div>
              </div>
            ))}
          </div>
          {Number(grid.data.rowsCount) > Number(grid.data.perPage) && (
            <div className="sidebar__pagination">
              <PagePagination
                page={grid.data.page}
                perPage={grid.data.perPage}
                count={grid.data.rowsCount}
                pageRangeDisplayed={3}
                controlFunc={grid.actions.readPage}
                hideFirstLastPages={false}
                hideNavigation={true}
                minimalStyle={true}
                scrollToTop={false}
              />
            </div>
          )}
        </div>
      </div>
    ) : null
  ) : (
    <FiltersContentLoader />
  );
});

CommunicationsWidget.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default CommunicationsWidget;
